module.exports = __webpack_public_path__ + "img/seaPalace-2.6ff10a84.jpg";